import { VariantProps } from "class-variance-authority"
import { t } from "i18next"
import { Banner, bannerVariants } from "@/components/ui/banner"
import { Flexibility, Urgency } from "@/types/__generated__/union-types"

const InformBanner = ({ medicalUrgency, flexibility }: { medicalUrgency: Urgency; flexibility: Flexibility }) => {
  let variant: VariantProps<typeof bannerVariants>["variant"] = "info"
  let message = ""

  switch (medicalUrgency) {
    case "NORMAL":
      switch (flexibility) {
        case "FLEXIBLE":
          message = t("patient.agenda.urgency.inform.default")
          break
        case "NOT_EARLIER":
          message = t("patient.agenda.urgency.inform.notEarlier")
          break
        case "FIXED_TIME":
          message = t("patient.agenda.urgency.inform.fixedTime")
          variant = "warning"
          break
      }
      break
    case "MEDICAL_URGENT":
      message = t("patient.agenda.urgency.inform.urgent")
      variant = "critical"
      break
    case "MEDICAL_ACUTE":
      message = t("patient.agenda.urgency.inform.acute")
      variant = "critical"
      break
  }

  return (
    <Banner type="inline" variant={variant} data-testid="patient-urgency-flexibility-message">
      {message}
    </Banner>
  )
}

export { InformBanner }
